import { ProcessDetailsPage } from '@/components/dashboard/ProcessDetailsPage';
import {
  ANOMALY_SEVERITIES,
  type VerificationResultFilter,
} from '@/core/model/verification-result';
import { createFileRoute } from '@tanstack/react-router';
import * as v from 'valibot';

export const Route = createFileRoute('/_authenticated/process/$processId')({
  component: ProcessDetailsPage,
  validateSearch: v.object({
    resultsFilter: v.optional(
      v.picklist([
        'all',
        'correct',
        'attention',
        'proofreading_failed',
        'customer_approval_requested',
      ] satisfies VerificationResultFilter[]),
      'all',
    ),
    resultsPage: v.optional(v.number(), 0),
    resultsSeverity: v.optional(v.picklist(ANOMALY_SEVERITIES)),
    resultsSkills: v.optional(
      v.pipe(
        v.union([v.array(v.string()), v.string()]),
        v.transform((value) => (Array.isArray(value) ? value : [value])),
      ),
      [],
    ),
  }),
});
